const I18n = require('react-redux-i18n').I18n;

export const validate = function (loginId, secureCode) {
    let isValid = true;
    const username = loginId.trim();
    const otp = secureCode.trim();

    let usernameError = '';
    let otpError = '';

    if (username === '') {
        isValid = false;
        usernameError = I18n.t("login.validation.fieldRequired", {fieldName: "Login ID"})
    }
    if (otp === '') {
        isValid = false;
        otpError = I18n.t("login.validation.fieldRequired", {fieldName: "Security Code"})
    }

    return {usernameError: usernameError,
            otpError: otpError,
            isValid: isValid}
};